import type { ReactNode } from "react";
import "./Zones.css";

/**
 * 5ゾーンのレイアウトプリミティブ（spec/design/screen-flow.md §7.1）。
 * 新しいゾーンを作らない。すべての画面はこの組み合わせで表現する。
 */

interface ZoneProps {
  readonly children?: ReactNode;
  readonly className?: string;
}

/** Z1 ヘッダー: 上端固定・高さ56px・全幅。現在地の表示・脱出口・全体設定。 */
export function HeaderZone({ children, className }: ZoneProps) {
  return <header className={["z-header", className].filter(Boolean).join(" ")}>{children}</header>;
}

/** Z2 主領域: 最大幅1120px中央。その画面の主役だけを置く。 */
export function MainZone({ children, className }: ZoneProps) {
  return <main className={["z-main", className].filter(Boolean).join(" ")}>{children}</main>;
}

/** Z3 補助領域: 主領域の下端。進行状況・副次操作。 */
export function AuxZone({ children, className }: ZoneProps) {
  return <div className={["z-aux", className].filter(Boolean).join(" ")}>{children}</div>;
}

/** Z4 フロート: 右下・幅132px。師範代の常駐。 */
export function FloatZone({ children, className }: ZoneProps) {
  return <div className={["z-float", className].filter(Boolean).join(" ")}>{children}</div>;
}
